<template>
    <v-dialog class="loading-dialog fill-height" v-model="loading" persistent no-click-animation transition="fade-transition" fullscreen fluid>
        <v-container fluid fill-height class="d-flex justify-center align-center flex-column loading-overlay" :style="background" :class="{'bg-img': !!background}">
            <v-progress-linear v-if="loading" :active="loading" :indeterminate="loading" height="1" absolute top color="secondary" ></v-progress-linear>

            <div class="logo-wrapper">
                <v-scale-transition appear>
                    <logo :link="false" />
                </v-scale-transition>
            </div>
            <div class="mx-auto my-12">
                <!-- <v-progress-linear v-if="loading" :active="loading" :indeterminate="loading" height="3" color="primary" style="width: 125px" ></v-progress-linear> -->
                <v-progress-circular indeterminate transition="fade-transition" :color="color ? color : 'primary lighten-1'" size="45" width="2"></v-progress-circular>
            </div>
        </v-container>
    </v-dialog>    
</template>
<script>
export default {
    props: ['loading', 'background', 'color', 'noSpinner'],
    components: {},
}
</script>
<style lang="scss" scoped>
    .loading-dialog{
        z-index: 100;
    }
    .loading-overlay{
        background-color: rgba(255, 255, 255, 0.97);
        &.bg-img{
            background-size: cover;
            background-position: bottom center;
            background-attachment: fixed;
            background-repeat: no-repeat;
            background-blend-mode: overlay;
        }
        z-index: 100;
    }
    .logo-wrapper{
        // height: 30vh;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        .logo{
            height: auto;
        }
    }
</style>